import { collectionsData } from '~/js/utilities/products-and-collections';

const getPrintsData = (data = [], prints = []) => {
  const items = data.map((item) => {
    const printData = prints.find((print) => print.query?.includes(item.value));
    const collection = printData ? collectionsData[printData.id] : null;
    const imageUrl = collection
      ? collection.iconImage?.reference?.image?.url
      : null;
    const swatch = collection
      ? {
          image: imageUrl
            ? `url(${imageUrl}&width=128&height=128&crop=center)`
            : null,
        }
      : {};

    return {
      ...item,
      collection,
      objectID: printData ? printData.id : '',
      swatch: swatch ? swatch : {},
    };
  });

  return items;
};

const getPrintCollectionsData = (data = [], printsCollections = []) => {
  return data
    .map((item) => {
      const collection = collectionsData[item.value];
      if (!collection) return null;

      const imageUrl = collection
        ? collection.iconImage?.reference?.image?.url
        : null;
      const swatch = collection
        ? {
            image: imageUrl
              ? `url(${imageUrl}&width=128&height=128&crop=center)`
              : null,
          }
        : {};

      return {
        ...item,
        label: collection.iconTitle?.value || collection.title,
        swatch: swatch ? swatch : {},
      };
    })
    .filter(Boolean)
    // .sort((a, b) => a.label.localeCompare(b.label));
};

const algoliaFacetItem = (key) => ({
  key: key,
  expanded: false,

  get data() {
    if (!this.algoliaFacetsData[this.key]) return null;

    return this.algoliaFacetsData[key];
  },

  get facetLabel() {
    if (this.key === 'age_group') return 'Age';
    if (this.key === 'inventory_available') return 'Availability';
    if (this.key === 'print_collection') return 'Print';
    if (this.key === 'subcategory') return 'Style';

    return this.key
      .replace('_', ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  },

  get items() {
    if (this.key === 'print_collection') {
      const items = getPrintCollectionsData(
        this.data?.items,
        this.printsCollections
      );

      return items;
    }

    return this.data?.items;
  },

  get canToggleShowMore() {
    return this.data?.canToggleShowMore;
  },

  get canRefine() {
    // if (this.key === 'price') return true;
    return this.data?.canRefine;
  },

  get isOpen() {
    return this.data?.isShowingMore;
  },

  toggleShowMore() {
    this.data?.toggleShowMore && this.data.toggleShowMore();
  },

  toggleWrapper() {
    this.expanded = !this.expanded;
  },

  refine(value) {
    this.data?.refine && this.data.refine(value);
  },
});

export default algoliaFacetItem;
